if(window.innerWidth > 960){
  
  const scrollTopBtn = document.querySelector(".scrollTopBtn");
  const rootElement = document.documentElement.scrollTop;

  const handleScroll = () => {
    // Get the current scroll value
    let y = window.scrollY;
    // If the scroll value is greater than the window height, let's add a class to the scrollTopBtn button to show it!
    if (y > 500) {
      scrollTopBtn.classList.add("scrollTopBtn--show");
    } else {
      scrollTopBtn.classList.remove("scrollTopBtn--show");
    }
  };

  document.addEventListener("scroll", handleScroll)

  const scrollToTop = () => {
    // Let's set a variable for the number of pixels we are from the top of the document.
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    
    // If that number is greater than 0, we'll scroll back to 0, or the top of the document.
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      // ScrollTo takes an x and a y coordinate.
      // Increase the '10' value to get a smoother/slower scroll! 
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }
  };
  
  // When the button is clicked, run our ScrolltoTop function above!
  scrollTopBtn.onclick = function(e) {
    e.preventDefault();
    scrollToTop();
  }

}


